import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './shared/components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import LandingPage from './pages/LandingPage';
import HeadlineGeneratorTool from './tools/headline-generator';
import ProfilePictureGeneratorTool from './tools/profile-picture-generator';
import BannerGeneratorTool from './tools/banner-generator';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}

function RouteMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const routeMeta = [
      {
        match: (p) => p === '/' || p === '',
        title: 'Free LinkedIn Tools by Growleads.io | Profile Optimization & Lead Generation',
        favicon: '/tools-trans.png',
      },
      {
        match: (p) => p.startsWith('/linkedin-headline-generator'),
        title: 'LinkedIn Headline Generator | Free AI-Powered Tool by Growleads.io',
        favicon: '/headline-tool-tans.png',
      },
      {
        match: (p) => p.startsWith('/linkedin-profile-picture-generator'),
        title: 'Professional LinkedIn Profile Picture Generator | Free AI Headshot Tool by Growleads.io',
        favicon: '/profile-tool-trans.png',
      },
      {
        match: (p) => p.startsWith('/linkedin-banner-generator'),
        title: 'Professional LinkedIn Banner Generator | Free AI-Powered Tool by Growleads.io',
        favicon: '/Banner trans.png',
      },
    ];

    const meta = routeMeta.find((m) => m.match(pathname)) || routeMeta[0];

    document.title = meta.title;

    const faviconEl = document.getElementById('favicon');
    if (faviconEl) faviconEl.setAttribute('href', meta.favicon);

    const appleTouchEl = document.getElementById('apple-touch-icon');
    if (appleTouchEl) appleTouchEl.setAttribute('href', meta.favicon);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <RouteMeta />
        <Toaster position="top-right" />
        <Routes>
        {/* Landing Page - tools.growleads.io */}
        <Route path="/" element={<LandingPage />} />
        
        {/* LinkedIn Headline Generator Tool */}
        <Route path="/linkedin-headline-generator" element={<HeadlineGeneratorTool />} />
        
        {/* Profile Picture Generator Tool */}
        <Route path="/linkedin-profile-picture-generator" element={<ProfilePictureGeneratorTool />} />
        
        {/* LinkedIn Banner Generator Tool */}
        <Route path="/linkedin-banner-generator" element={<BannerGeneratorTool />} />
        
        {/* 
          Future tools will be added here:
          <Route path="/linkedin-summary-generator" element={<SummaryGeneratorTool />} />
          <Route path="/linkedin-post-generator" element={<PostGeneratorTool />} />
          <Route path="/linkedin-profile-analyzer" element={<ProfileAnalyzerTool />} />
        */}
        
        {/* Fallback to landing page for unknown routes */}
        <Route path="*" element={<LandingPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
